/* Vedic Tithi Store — Theme JS */

// ── Mobile menu toggle ──
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('MobileMenuToggle');
  const drawer = document.getElementById('MobileDrawer');
  const icon   = document.getElementById('MobileMenuIcon');

  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      const open = drawer.classList.toggle('vt-mobile-drawer--open');
      toggle.setAttribute('aria-expanded', open);
      if (icon) icon.textContent = open ? '✕' : '☰';
    });
  }

  // ── Mobile search toggle ──
  const searchToggle = document.getElementById('MobileSearchToggle');
  const searchBar    = document.getElementById('MobileSearch');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      const open = searchBar.classList.toggle('vt-mobile-search--open');
      searchToggle.setAttribute('aria-expanded', open);
      if (open) {
        const input = searchBar.querySelector('.vt-header__search-input');
        if (input) input.focus();
      }
    });
  }

  // ── Desktop nav dropdowns ──
  document.querySelectorAll('.vt-nav__item[data-has-dropdown]').forEach(function (item) {
    const link    = item.querySelector('.vt-nav__link');
    const dropdown = item.querySelector('.vt-nav__dropdown');

    if (!link || !dropdown) return;

    function openMenu() { item.classList.add('vt-nav__item--open'); }
    function closeMenu() { item.classList.remove('vt-nav__item--open'); }

    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeMenu);
    link.addEventListener('click', function (e) {
      if (item.classList.contains('vt-nav__item--open')) {
        closeMenu();
      } else {
        e.preventDefault();
        document.querySelectorAll('.vt-nav__item--open').forEach(i => i.classList.remove('vt-nav__item--open'));
        openMenu();
      }
    });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.vt-nav__item')) {
      document.querySelectorAll('.vt-nav__item--open').forEach(i => i.classList.remove('vt-nav__item--open'));
    }
  });

  // ── Product page: thumbnail gallery ──
  const thumbs      = document.querySelectorAll('.vt-product-page__thumb');
  const mediaPanels = document.querySelectorAll('.vt-product-page__main-media');

  // ── Product page: hover-to-zoom magnifier (images only — video/3D panels opt out) ──
  const zoomWrap = document.getElementById('ProductMainImageWrap');
  const zoomLens = document.getElementById('ZoomLens');
  const zoomPane = document.getElementById('ZoomPane');
  const canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const ZOOM_FACTOR = 2.5;
  let zoomEnabled = true;

  function setZoomSource(src) {
    if (zoomPane && src) zoomPane.style.backgroundImage = 'url(' + src + ')';
  }

  function activePanelZoomSrc() {
    const active = document.querySelector('.vt-product-page__main-media--active');
    const img = active && active.querySelector('img[data-zoom-src]');
    return img ? img.getAttribute('data-zoom-src') : null;
  }

  if (zoomWrap && zoomLens && zoomPane && canHoverZoom) {
    setZoomSource(activePanelZoomSrc());

    zoomWrap.addEventListener('mouseenter', function () {
      if (!zoomEnabled) return;
      const rect = zoomWrap.getBoundingClientRect();
      zoomLens.style.width = (rect.width / ZOOM_FACTOR) + 'px';
      zoomLens.style.height = (rect.height / ZOOM_FACTOR) + 'px';
      zoomPane.style.backgroundSize = (rect.width * ZOOM_FACTOR) + 'px ' + (rect.height * ZOOM_FACTOR) + 'px';
      zoomLens.style.display = 'block';
      zoomPane.style.display = 'block';
      zoomWrap.classList.add('vt-product-page__main-img--zoom-active');
    });

    zoomWrap.addEventListener('mouseleave', function () {
      zoomLens.style.display = 'none';
      zoomPane.style.display = 'none';
      zoomWrap.classList.remove('vt-product-page__main-img--zoom-active');
    });

    zoomWrap.addEventListener('mousemove', function (e) {
      if (!zoomEnabled) return;
      const rect = zoomWrap.getBoundingClientRect();
      const lensW = zoomLens.offsetWidth;
      const lensH = zoomLens.offsetHeight;
      let x = e.clientX - rect.left - lensW / 2;
      let y = e.clientY - rect.top - lensH / 2;
      x = Math.max(0, Math.min(x, rect.width - lensW));
      y = Math.max(0, Math.min(y, rect.height - lensH));
      zoomLens.style.left = x + 'px';
      zoomLens.style.top = y + 'px';
      zoomPane.style.backgroundPosition = '-' + (x * ZOOM_FACTOR) + 'px -' + (y * ZOOM_FACTOR) + 'px';
    });
  }

  function activateThumb(thumb) {
    if (!thumb) return;
    thumbs.forEach(t => t.classList.remove('vt-product-page__thumb--active'));
    thumb.classList.add('vt-product-page__thumb--active');

    const mediaId = thumb.getAttribute('data-media-id');
    let activeType = 'image';
    mediaPanels.forEach(function (panel) {
      const isActive = panel.getAttribute('data-media-id') === mediaId;
      panel.classList.toggle('vt-product-page__main-media--active', isActive);
      if (isActive) {
        activeType = panel.getAttribute('data-media-type');
      } else {
        // Pause any playing video when its panel is hidden
        const video = panel.querySelector('video');
        if (video && !video.paused) video.pause();
      }
    });

    zoomEnabled = activeType === 'image';
    if (zoomWrap) zoomWrap.classList.toggle('vt-product-page__main-img--no-zoom', !zoomEnabled);
    setZoomSource(activePanelZoomSrc());
  }

  function activateThumbByMediaId(mediaId) {
    if (mediaId == null) return;
    const match = Array.from(thumbs).find(function (t) {
      return t.getAttribute('data-media-id') === String(mediaId);
    });
    if (match) activateThumb(match);
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateThumb(thumb);
    });
  });

  // ── Quantity buttons ──
  document.querySelectorAll('.vt-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = btn.closest('.vt-product-page__qty')?.querySelector('.vt-qty-input');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (btn.dataset.action === 'plus') val += 1;
      input.value = val;
    });
  });

  // ── Variant buttons ──
  // Mirrors Shopify's reference formatMoney (theme-scripts): handles every money_format placeholder variant.
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    const number = (cents / 100).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    const centsPart = parts[1] ? decimal + parts[1] : '';
    return dollars + centsPart;
  }

  function formatMoney(cents, format) {
    const formatString = format || '${{amount}}';
    const match = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return formatString;

    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return formatString.replace(match[0], value);
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    const variantScript = form.previousElementSibling;
    if (!variantScript || !variantScript.matches('[data-product-variants]')) return;

    let variants;
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      return;
    }

    const optionGroups = Array.from(form.querySelectorAll('[data-option-name]'));
    const idInput = form.querySelector('[data-variant-id-input]');
    const submitBtn = form.querySelector('[data-add-to-cart-btn]');
    const priceCurrentEl = form.parentElement.querySelector('[data-price-current]');
    const priceCompareEl = form.parentElement.querySelector('[data-price-compare]');
    const stickyPriceEl = document.querySelector('[data-sticky-price]');
    const stickyAddBtn = document.querySelector('[data-sticky-add-btn]');
    const soldOutBadge = document.getElementById('SoldOutBadge');

    // Seed selections from whichever button server-rendered as active per option group.
    const selections = {};
    optionGroups.forEach(function (group) {
      const activeBtn = group.querySelector('.vt-variant-btn--active');
      if (activeBtn) selections[group.dataset.optionName] = activeBtn.dataset.value;
    });

    function findVariantFor(sel) {
      return variants.find(function (variant) {
        return optionGroups.every(function (group, index) {
          return variant['option' + (index + 1)] === sel[group.dataset.optionName];
        });
      });
    }

    function findVariant() {
      return findVariantFor(selections);
    }

    // ── Quantity-tier picker: keeps each tier card's per-item price/badge in
    // sync when a *different* option (e.g. Size) changes which variant a tier maps to.
    const tierGroup = form.querySelector('[data-quantity-tier-group]');

    function refreshTierPrices() {
      if (!tierGroup) return;
      const tierOptionName = tierGroup.dataset.optionName;
      tierGroup.querySelectorAll('[data-tier-qty]').forEach(function (card) {
        const candidate = Object.assign({}, selections);
        candidate[tierOptionName] = card.dataset.value;
        const variant = findVariantFor(candidate);
        if (!variant) return;

        const tierQty = parseInt(card.dataset.tierQty, 10) || 1;
        const priceEl = card.querySelector('[data-tier-price-per-item]');
        if (priceEl) priceEl.textContent = formatMoney(Math.round(variant.price / tierQty), window.vtMoneyFormat);

        const compareEl = card.querySelector('[data-tier-compare-per-item]');
        const badgeEl = card.querySelector('[data-tier-badge]');
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) compareEl.textContent = formatMoney(Math.round(variant.compare_at_price / tierQty), window.vtMoneyFormat);
        if (badgeEl) badgeEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price, window.vtMoneyFormat);
        if (compareEl) compareEl.hidden = !onSale;
        if (badgeEl) badgeEl.hidden = !onSale;

        card.disabled = !variant.available;
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (idInput) idInput.value = '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Unavailable';
        }
        if (stickyAddBtn) {
          stickyAddBtn.disabled = true;
          stickyAddBtn.textContent = 'Unavailable';
        }
        if (soldOutBadge) soldOutBadge.hidden = false;
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (stickyAddBtn) {
        stickyAddBtn.disabled = !variant.available;
        stickyAddBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (soldOutBadge) soldOutBadge.hidden = variant.available;

      const variantMedia = variant.featured_media || variant.featured_image;
      if (variantMedia) {
        activateThumbByMediaId(variantMedia.id);
      }

      if (priceCurrentEl) {
        priceCurrentEl.textContent = formatMoney(variant.price, window.vtMoneyFormat);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceCurrentEl.classList.toggle('vt-product-page__price-current--sale', !!onSale);
        if (priceCompareEl) {
          if (onSale) {
            priceCompareEl.textContent = formatMoney(variant.compare_at_price, window.vtMoneyFormat);
            priceCompareEl.removeAttribute('hidden');
          } else {
            priceCompareEl.setAttribute('hidden', '');
          }
        }
      }
      if (stickyPriceEl) {
        stickyPriceEl.textContent = formatMoney(variant.price, window.vtMoneyFormat);
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.vt-variant-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.vt-variant-btn').forEach(function (b) {
            b.classList.remove('vt-variant-btn--active');
          });
          btn.classList.add('vt-variant-btn--active');
          selections[group.dataset.optionName] = btn.dataset.value;
          updateForVariant(findVariant());
          refreshTierPrices();
        });
      });
    });
  });

  // ── Collection page: mobile filters drawer ──
  const filtersToggle = document.getElementById('FiltersToggle');
  const filtersPanel = document.getElementById('CollectionFilters');
  const filtersClose = document.getElementById('FiltersClose');
  const filtersBackdrop = document.getElementById('FiltersBackdrop');

  function setFiltersOpen(open) {
    if (!filtersPanel) return;
    filtersPanel.classList.toggle('vt-filters--open', open);
    if (filtersBackdrop) filtersBackdrop.classList.toggle('vt-filters-backdrop--visible', open);
    if (filtersToggle) filtersToggle.setAttribute('aria-expanded', String(open));
  }

  if (filtersToggle) filtersToggle.addEventListener('click', function () { setFiltersOpen(true); });
  if (filtersClose) filtersClose.addEventListener('click', function () { setFiltersOpen(false); });
  if (filtersBackdrop) filtersBackdrop.addEventListener('click', function () { setFiltersOpen(false); });

  // ── Product page: detail accordion ──
  document.querySelectorAll('.vt-accordion-item__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const item = trigger.closest('.vt-accordion-item');
      const isOpen = item.classList.contains('vt-accordion-item--open');
      item.classList.toggle('vt-accordion-item--open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // ── Product page: sticky mobile buy bar ──
  const stickyBar = document.getElementById('StickyBuyBar');
  const mainAddBtn = document.querySelector('[data-add-to-cart-btn]');
  if (stickyBar && mainAddBtn && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('vt-sticky-buy--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(mainAddBtn);
  }

  // ── Outbound link click tracking (WhatsApp, Amazon) ──
  // Published as Shopify custom events; the "WhatsApp click → GA4" custom pixel
  // (Admin → Settings → Customer events) forwards them to GA4.
  function publishEvent(name, data) {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, data);
    }
  }
  function trackWhatsApp(data) { publishEvent('whatsapp_click', data); }

  const amazonLink = document.querySelector('[data-amazon-link]');
  if (amazonLink) {
    amazonLink.addEventListener('click', function () {
      publishEvent('amazon_click', {
        location: 'product_trust_row',
        product: amazonLink.dataset.product || '',
        sku: amazonLink.dataset.sku || ''
      });
    });
  }
  const waFloat = document.querySelector('[data-wa-float]');
  if (waFloat) {
    waFloat.addEventListener('click', function () {
      trackWhatsApp({
        location: 'float',
        page_type: waFloat.dataset.pageType || '',
        product: waFloat.dataset.product || ''
      });
    });
  }
  document.querySelectorAll('.vt-footer a[href*="wa.me"]').forEach(function (link) {
    link.addEventListener('click', function () { trackWhatsApp({ location: 'footer' }); });
  });

  // ── Newsletter form ──
  const nlForm = document.getElementById('NewsletterForm');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = nlForm.querySelector('input[type="email"]');
      if (input && input.value) {
        const msg = document.getElementById('NewsletterMsg');
        if (msg) {
          msg.textContent = 'Thank you for subscribing! 🙏';
          msg.style.color = '#4a5954';
          msg.style.marginTop = '0.75rem';
        }
        input.value = '';
      }
    });
  }

  // ── Cart discount code ──
  const discountForm = document.getElementById('CartDiscountForm');
  if (discountForm) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = document.getElementById('CartDiscountInput');
      const code = input && input.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });
  }
});
